export const SEND_OPEN_POOL_REQUESTS_REQUEST = 'SEND_OPEN_POOL_REQUESTS_REQUEST';

export const sendOpenPoolRequestsRequest = ( ids ) => ({
    type: SEND_OPEN_POOL_REQUESTS_REQUEST,
    payload: { ids },
});
